module.exports = __webpack_public_path__ + "static/media/ice_cream.c760f5dc.svg";